import { useMutation } from '@tanstack/react-query';
import type { AgentApiProfitsShow } from '@/types/serializers';

type Params = { id: number; date: string };

export default function useSendInvoice() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ id, date }: Params) => {
      const res = await fetch(`/agent/api/profits/${id}/send_invoice`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ date }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.errors?.join(', ') || '請求書送付の登録に失敗しました');
      }
      const data: AgentApiProfitsShow = await res.json();
      return data;
    },
  });
}
